import React from 'react'
import './PageTitle.css'

function PageTitle({ text, className }) {
    return text ? <h1 className={`pageTitle ${className}`}>{text}</h1> : ''
}

export default PageTitle
